module.exports = "<mat-paginator #paginacao (page)=\"onPagination($event)\" [length]=\"totalPaginas\" [pageSize]=\"tamanhoPagina\" [pageIndex]=\"indicePagina\" [pageSizeOptions]=\"[5, 10, 20]\">\n</mat-paginator>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/paginacao/paginacao.component.html
// module id = ./src/app/components/paginacao/paginacao.component.html
// module chunks = main